import _ from "lodash";
import filter from "@/filter/filter.sub.js";
import betweenPrice from "@/components/CostManage/betweenPrice.vue"
import editEle from "@/components/CostManage/editEle.vue"
import selectEle from "@/components/CostManage/selectEle.vue";
import BSwitch from "@/components/inputstyle/inputcheck.vue";
export default {
  data() {
    return {
      stockShow: [],
      stockempty: '',
      //   stockStatus: 0,
      openeditEle: {
        type: "insert",
        thdata: null,
        show: false,
        importEleShow: false,
        importSelectList: []
      },
      stockMethod: {
        single: {
          value: 1
        },
        multiple: {
          value: 2
        },
        case: {
          value: 3
        }
      },
      single: {
        method: "pro", //adv 進階
        list: [{
          name: "商品庫存模式",
          value: "pro"
        }, {
          name: "項目庫存模式",
          value: "adv"
        }]
      }
    }
  },

  methods: {
    changeinput(name, value, node = "") {
      console.log(value);
      if (node) {
        this.thdata[node][name] = value;
      } else {
        this.thdata[name] = value;
      }
    },
    changeinputpush(name, value, node = "") {
      let tmp = null;
      if (node) {
        tmp = this.thdata[node][name];
      } else {
        tmp = this.thdata[name];
      }
      if (tmp.indexOf(value) > -1) {
        tmp.splice(tmp.indexOf(value), 1);
      } else {
        tmp.push(value);
      };
    },
    openselectElement(model, method, data) {
      if (model == "editEle") {
        this.openeditEle.show = !this.openeditEle.show;
      } else if (model == "selectEle") {
        this.openeditEle.importEleShow = !this.openeditEle.importEleShow
        this.openeditEle.importSelectList = data.element;
      }
      this.openeditEle.type = method;
      this.openeditEle.thdata = data
    },
    saveElement(data) {
      console.log(data);
      const tmp = _.clone(data.data);
      tmp.uid = data.uid;
      tmp.number = 1;
      tmp.webshow = 0;
      tmp.delete = 0;
      tmp.showremark = 1;
      this.openeditEle.thdata.element.push(tmp);
    },
    saveselectElement(data) {
      const tmp = _.clone(data.data);
      _.each(tmp, (item, keys) => {
        if (item.delete == 0) {
          if (filter.filter(this.openeditEle.thdata.element, {
              uid: keys,
              delete: 0
            }).length == 0) {
            item.delete = 0;
            item.number = 1;
            item.webshow = 1;
            item.showremark = 0;
            // item.
            this.openeditEle.thdata.element.push(item);
          }
        } else {
          if (filter.filter(this.openeditEle.thdata.element, {
              uid: keys,
              delete: 0
            }).length > 0) {
            const tmp = filter.filter(this.openeditEle.thdata.element, {
              uid: keys,
              delete: 0
            })[0];
            tmp.delete = 1;
          }
        }
        // this.openeditEle.thdata.element.push(tmp);
      })

    }
  },
  computed: {
    findEle() {
      return (data) => {
        return _.filter(data.element, {
          delete: 0
        });
      }
    },
    nowSpecification: {
      get() {
        return this.specdata.method
      },
    },
    stockStatus: {
      get() {
        return this.thdata.product.inventorymethod;
      },
      set(data) {
        this.changeinput("inventorymethod", data, "product");
      }
    },
    matchCost() {
      return (uid) => {
        if (!this.thdata.spec[uid]) {
          return {
            cargonumber: 0,
            selfcargo: 0,
            use: 0,
            delete: 0
          };
          this.thdata.spec[uid] = {
            cargonumber: 0,
            selfcargo: 0,
            use: 0,
            delete: 0
          }
        } else {
          return this.thdata.spec[uid];
        }

      }
    },
    specdata() {
      return this.data['insSpecification'];
    },
    basedata() {
      return this.data['insBaseField'];
    },
    thdata() {
      return this.data[this.pagename];
    },
  },
  created() {
    this.stockStatus = this.specdata.method == "single" ? 1 : (this.specdata.method == "multiple" ?
      2 : 3);
    // (this.stockStatus == 1 ? this.stockMethod[this.specdata.method].value : this
    //   .stockStatus)
    // console.log(stockStatus);
    this.single.method = (this.specdata.method == "single" && this.specdata.speCheck) ? this.single
      .method : "pro";
  },
  props: {
    data: Object,
    pagename: String
  },
  components: {
    editEle,
    selectEle,
    BSwitch
  }

};
